export const TRANSLATIONS_API_URL: string = '/api/translations'
export const TRANSLATIONS_HASH_URL: string = '/api/translations/hash'
export const FILTERS_API_URL: string = '/api/filters'
export const ASSETS_API_URL: string = '/api/assets'
export const ASSET_METERS_API_URL: string = '/api/asset-meters'

export function GET_ASSET_METERS_URL(assetId: string | number): string {
    return `/api/assets/${assetId}/meters`
}
export function GET_METER_CONSUMPTIONS_URL(assetId: string | number, meterId: string | number): string {
    return `/api/assets/${assetId}/meters/${meterId}/consumptions`
}
export function GET_METER_GRANULAR_CONSUMPTIONS_URL(portfolioId: string | number, assetId: string | number, meterId: string | number): string {
    return `/api/portfolios/${portfolioId}/in-meters/${assetId}/${meterId}/granular-consumptions`
}
export function GET_METER_GRANULAR_CONSUMPTION_URL(portfolioId: string | number, assetId: string | number, meterId: string | number, consumptionId: string | number): string {
    return `/api/portfolios/${portfolioId}/in-meters/${assetId}/${meterId}/granular-consumptions/${consumptionId}`
}
export function BULK_DELETE_GRANULAR_CONSUMPTIONS_URL(portfolioId: string | number, assetId: string | number, meterId: string | number): string {
    return `/api/portfolios/${portfolioId}/in-meters/${assetId}/${meterId}/granular-consumptions/bulk-delete`
}
export function EXPORT_GRANULAR_CONSUMPTIONS_URL(portfolioId: string | number, assetId: string | number, meterId: string | number): string {
    return `/api/portfolios/${portfolioId}/in-meters/${assetId}/${meterId}/granular-consumptions/export`
}
export function IMPORT_GRANULAR_CONSUMPTIONS_URL(portfolioId: string | number, assetId: string | number, meterId: string | number): string {
    return `/api/portfolios/${portfolioId}/in-meters/${assetId}/${meterId}/granular-consumptions/import`
}
export const AI_CONVERSE: string = '/api/ai/converse'
export const AI_INVOKE_AGENT: string = '/api/ai/invoke_agent'
export const AI_FEEDBACK: string = '/api/ai/feedback'
export const AI_PROMPT_PAGES: string = '/api/ai/prompt-pages'

export const REPORTS_FOR_PORTFOLIO_URL = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/reports`
}
export const FRAMEWORK_REQUIRED_FIELDS_URL = '/api/frameworks/required-fields'
export const DOWNLOAD_BLANK_TEMPLATE_API_URL = '/api/download-template'
export const SURVEY_SECTIONS_API_URL = '/api/surveys/sections/fields'
export const DOWNLOAD_ASSETS_FOR_PORTFOLIO_URL = (portfolio_id: string | number): string => {
    return `/api/portfolios/${portfolio_id}/start-export`
}
export const EXPORT_PORTFOLIO_ASSETS_URL = (portfolio_id: string | number): string => {
    return `/api/portfolios/${portfolio_id}/start-export`
}
export const ACTIVE_JOB_STATUS_FOR_PORTFOLIO_URL = (portfolio_id: string | number): string => {
    return `/api/portfolios/${portfolio_id}/status`
}
export const CHECK_ACTIVE_DATA_REQUESTS_URL = (portfolio_id: string | number): string => {
    return `/api/portfolios/${portfolio_id}/check-active-data-requests`
}
export const DOWNLOAD_ASSETS_FOR_JOB_ID_URL = (job_id: string): string => {
    return `/api/download-assets/${job_id}`
}
export const START_IMPORT_FOR_PORTFOLIO_URL = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/start-import`
}
export const DOWNLOAD_IMPORT_WITH_ERRORS_URL = (job_id: string): string => {
    return `/api/download-import-with-errors/${job_id}`
}
export const CREATE_SURVEY_API_URL: string = '/api/surveys/survey/create'
export const EDIT_SURVEY_API_URL = (survey_id: string | number): string => {
    return `/api/surveys/survey/${survey_id}`
}
export const CREATE_SURVEY_SECTIONS_API_URL = (survey_id: string): string => {
    return `/api/surveys/survey/${survey_id}/sections`
}
export const ASSIGN_SURVEY_ASSETS_API_URL = (survey_id: string | number): string => {
    return `/api/surveys/survey/${survey_id}/assets`
}
export const ASSIGN_SURVEY_CHECK_ASSETS_API_URL = (survey_id: string | number): string => {
    return `/api/surveys/survey/${survey_id}/check_assets`
}
export const GET_SINGLE_SURVEY_API_URL = (survey_id: string | number): string => {
    return `/api/surveys/survey/${survey_id}`
}
export const DELETE_SINGLE_SURVEY_API_URL = (survey_id: string | number): string => {
    return `/api/surveys/survey/${survey_id}`
}
export const GET_SURVEY_METERS_API_URL = (portfolioId: string | number): string => {
    return `/api/portfolios/${portfolioId}/in-meters/surveys-list`
}
export const GET_SURVEY_METERS_STATS_API_URL = (portfolioId: string | number): string => {
    return `/api/portfolios/${portfolioId}/in-meters/surveys-statistics`
}
export const GET_ALL_SURVEYS_API_URL = '/api/surveys'
export const LOGOUT_URL = '/api/auth/logout'
export const AUTH_LOGIN_URL = '/api/auth/login'
export const AUTH_SSO_LOGIN_URL = '/api/auth/sso-login'
export const AUTH_SSO_EXCHANGE_URL = '/api/auth/sso-exchange'
export const AUTH_FORGOT_PASSWORD_URL = '/api/auth/forgot-password'
export const AUTH_RESET_PASSWORD_URL = '/api/auth/reset-password'
export const AUTH_TERMS_AND_PRIVACY_POLICY_URLS = '/api/auth/terms-and-privacy-policy'
export const USER_PROFILE_URL = '/api/user/profile'
export const USER_SESSIONS_URL = '/api/user/sessions'
export const USER_2FA_URL = '/api/user/2fa'
export const USER_REGENERATE_RECOVERY_CODES_URL = '/api/user/recovery-codes/regenerate'
export const USER_SHOW_RECOVERY_CODES_URL = '/api/user/recovery-codes/show'
export const USER_LOGOUT_OTHER_SESSIONS_URL = '/api/user/logout-other-sessions'
export const USER_UPDATE_PASSWORD_URL = '/api/user/update-password'
export const USER_UPDATE_ACCOUNT_URL = '/api/user/update-account'
export const USER_DELETE_ACCOUNT = '/api/user/delete-account'
export const BREADCRUMBS_URL: string = '/api/breadcrumbs'
export const BREADCRUMBS_DEFAULTS_URL: string = '/api/breadcrumbs/default-values'
export const NAVIGATION_COMPANIES_API_URL: string = '/api/labs/navigation/companies'
export const NAVIGATION_COMPANY_HIERARCHY_API_URL: string = '/api/labs/navigation/company-hierarchy'
export const COMPANY_USERS_URL = '/api/users'
export const ROLES_URL = '/api/roles'
export const ORGANIZATION_ROLES_URL = '/api/organization-roles'
export const COMPANY_SINGLE_USER_URL = (user_id: number): string => {
    return `/api/users/${user_id}`
}
export const CONSULTANTS_URL = (company_id: number): string => {
    return `/api/companies/${company_id}/consultants`
}
export const CONSULTANT_GRANT_ACCESS_URL = (company_id: number): string => {
    return `/api/companies/${company_id}/consultants/grant-access`
}
export const CONSULTANT_URL = (company_id: number, consultant_id: number): string => {
    return `/api/companies/${company_id}/consultants/${consultant_id}`
}
export const COMPANY_INFO_URL = (company_id: number): string => {
    return `/api/companies/${company_id}`
}
export const COMPANY_PORTFOLIOS_URL = (company_id: number): string => {
    return `/api/companies/${company_id}/portfolios`
}
export const SURVEY_RECIPIENT_TOKEN_API_URL = '/api/surveys/recipient/token'
export const SURVEY_RECIPIENT_LOGIN_API_URL = '/api/surveys/recipient/login'
export const SURVEY_RECIPIENT_LOGOUT_API_URL = '/api/surveys/recipient/logout'
export const SURVEY_RECIPIENT_LIST_API_URL = '/api/surveys/recipient/assets/list'
export const SURVEY_RECIPIENT_LIST_API_URL_V2 = '/api/surveys/recipient/list'
export const SURVEY_RECIPIENT_PROFILE_API_URL = '/api/surveys/recipient/profile'

export const SURVEY_METERS_ACTIVITY_LOG_API_URL_V2 = (survey_id: string | number): string => {
    return `/api/surveys/recipient/${survey_id}`
}

export const SURVEY_RECIPIENT_METERS_MESSAGE_API_URL = (survey_id: string | number): string => {
    return `/api/surveys/recipient/${survey_id}/messages`
}
export const SURVEY_REVIEWER_METERS_MESSAGE_API_URL = (survey_id: string | number): string => {
    return `/api/surveys/${survey_id}/messages`
}
export const SINGLE_SURVEY_RECIPIENT_METERS_MESSAGE_API_URL = (survey_id: string | number, message_id: string | number): string => {
    return `/api/surveys/recipient/${survey_id}/messages/${message_id}`
}
export const SINGLE_SURVEY_REVIEWER_METERS_MESSAGE_API_URL = (survey_id: string | number, message_id: string | number): string => {
    return `/api/surveys/${survey_id}/messages/${message_id}`
}
export const SURVEY_REVIEWER_METERS_ACTIVITY_LOG_API_URL_V2 = (survey_id: string | number): string => {
    return `/api/surveys/survey/${survey_id}`
}
export const SURVEY_RECIPIENT_METERS_ACTIVITY_LOG_DOWNLOAD_API_URL = (survey_id: string | number, survey_activity_log_id: string | number): string => {
    return `/api/surveys/recipient/${survey_id}/activity-logs/${survey_activity_log_id}/download`
}
export const SURVEY_RECIPIENT_METERS_ACTIVITY_LOG_UPLOAD_API_URL = (survey_id: string | number): string => {
    return `/api/surveys/recipient/${survey_id}/activity-logs/upload`
}
export const SURVEY_REVIEWER_METERS_ACTIVITY_LOG_DOWNLOAD_API_URL = (survey_id: string | number, survey_activity_log_id: string | number): string => {
    return `/api/surveys/${survey_id}/activity-logs/${survey_activity_log_id}/download`
}
export const SURVEY_REVIEWER_METERS_ACTIVITY_LOG_UPLOAD_API_URL = (survey_id: string | number): string => {
    return `/api/surveys/${survey_id}/activity-logs/upload`
}

export const SURVEY_REVIEWER_APPROVE_METERS_SURVEY_API_URL = (survey_id: string | number): string => {
    return `/api/surveys/${survey_id}/approve-meters-survey`
}

export const UPDATE_IMPORT_STATUS_FOR_JOB_ID_URL = (job_id: string, action: string): string => {
    return `/api/imports/${job_id}/${action}`
}
export const INPUT_PAGES_FOR_PORTFOLIO_URL = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/input-pages`
}
export const GET_SINGLE_SURVEY_AS_RECIPIENT_API_URL = (survey_id: string): string => {
    return `/api/surveys/recipient/assets/${survey_id}`
}
export const GET_ANNUAL_DATA_AS_RECIPIENT_API_URL = (asset_id: string): string => {
    return `/api/surveys/recipient/assets/${asset_id}/annual_data/reports`
}
export const SEND_SURVEY_RESPONSE_AS_RECIPIENT_API_URL = (survey_id: string): string => {
    return `/api/surveys/recipient/assets/${survey_id}`
}
export const SEND_FINISHED_SURVEY_RESPONSE_AS_RECIPIENT_API_URL = (survey_id: string): string => {
    return `/api/surveys/recipient/assets/${survey_id}/submit`
}
export const SURVEY_RESPONSES_LIST_API_URL = '/api/surveys/assets'
export const SURVEY_RESPONSES_FILTERS_LIST_API_URL = '/api/surveys/filters'
export const SURVEY_STATISTICS_API_URL = (portfolio_id: string | number): string => {
    return `/api/surveys/statistics/${portfolio_id}`
}
export const GET_SINGLE_SURVEY_FOR_REVIEW_API_URL = (survey_id: string): string => {
    return `/api/surveys/assets/${survey_id}`
}
export const SEND_REMINDER_FOR_SURVEY_API_URL = (survey_id: string | number): string => {
    return `/api/surveys/assets/${survey_id}/reminder`
}
export const BULK_SEND_REMINDER_FOR_SURVEY_API_URL = `/api/surveys/bulk-reminder`
export const APPROVE_SURVEY_API_URL = (survey_id: string): string => {
    return `/api/surveys/assets/${survey_id}/approve`
}
export const REQUESTED_CHANGES_SURVEY_API_URL = (survey_id: string | number): string => {
    return `/api/surveys/assets/${survey_id}/request_changes`
}
export const EMISSION_FACTORS_STATUS_URL = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/emission-factors-status`
}
export const WEATHER_NORMALIZATION_DATA_STATUS_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/weather-normalization-status`
}
export const CERTIFICATION_TYPES_URL = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/certification-types`
}
export const TARGETS_URL = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/targets`
}
export const CERTIFICATED_PERCENTAGE_URL = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/certificated-percentage`
}
export const CERTIFICATION_STATS_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/certification-stats`
}
export const PROPERTY_TYPES_BY_FLOOR_AREA_URL = (portfolio_id: number | string, reporting_year: number | string): string => {
    return `/api/portfolios/${portfolio_id}/property-types/by-floor-area?reporting_year=${reporting_year}`
}
export const ASSET_INFO_URL = (asset_id: string | number): string => {
    return `/api/assets/${asset_id}/info`
}
export const REPLY_TO_REQUESTED_CHANGES_SURVEY_API_URL = (survey_id: string): string => {
    return `/api/surveys/recipient/assets/${survey_id}/reply`
}
export const SURVEY_RECIPIENT_FILTERS_LIST_API_URL = '/api/surveys/recipient/assets/filters'
export const ASSETS_GROUPED = '/api/measures/assets-grouped'
export const ASSET_MEASURE_TYPES_URL = '/api/asset-measure-types'
export const ENERGY_REDUCTION_TYPES_URL = '/api/energy-reduction-types'
export const ENERGY_REDUCTION_METHODS_URL = '/api/energy-reduction-methods'
export const UNITS_URL = '/api/units'
export const ASSET_MEASURES_URL = (asset_id: string | number): string => {
    return `/api/assets/${asset_id}/measures`
}
export const MEASURES_URL = '/api/measures'
export const ASSET_MEASURES_SYNC_URL = (asset_id: string): string => {
    return `/api/assets/${asset_id}/measures/sync`
}
export const PORTFOLIO_ACQUISITIONS_URL = (
    portfolio_id: string | number,
    acquisition_id?: string | number | null,
): string => {
    return `/api/portfolios/${portfolio_id}/roadmaps/acquisitions${acquisition_id ? '/' + acquisition_id : ''}`
}
export const ACQUISITIONS_STATISTICS_URL = (portfolio_id: string | number) => {
    return `/api/portfolios/${portfolio_id}/roadmaps/acquisition-statistics`
}
export const ACQUISITION_CONSUMPTIONS_URL = (
    portfolio_id: string | number,
    acquisition_id: string | number,
    acquisition_consumption_id = null,
): string => {
    return `/api/portfolios/${portfolio_id}/roadmaps/acquisitions/${acquisition_id}/consumptions${acquisition_consumption_id ? '/' + acquisition_consumption_id : ''
    }`
}
export const ACQUISITION_STATUSES_URL = '/api/acquisition-statuses'
export const ASSETS_ANALYTICS_API_URL: string = '/api/assets/analytics'
export const ASSETS_ANALYTICS_DOWNLOAD_API_URL: string = '/api/assets/analytics/download'
export const START_ASSET_ANALYTICS_EXPORT_URL: string = '/api/assets/start-analytics-export'
export const ASSET_ANALYTICS_EXPORT_STATUS_URL = (jobId: string | number): string => {
    return `/api/assets/analytics-export-status/${jobId}`
}
export const DOWNLOAD_ASSET_ANALYTICS_EXPORT_URL = (jobId: string | number): string => {
    return `/api/assets/download-analytics-export/${jobId}`
}
export const DELETE_ASSIGNED_SURVEY_API_URL = (survey_id: string | number): string => {
    return `/api/surveys/assets/${survey_id}`
}
export const ROADMAP_FILTERS_FOR_PORTFOLIO_URL = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/roadmaps/filters`
}
export const ROADMAP_FILTERS_FOR_PORTFOLIO_URL_V2 = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/roadmaps/filters/v2`
}
export const ROADMAP_NET_ZERO_CHARTS = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/roadmaps/charts/net-zero`
}
export const ROADMAP_NET_ZERO_CHARTS_PER_ASSET = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/roadmaps/charts/net-zero/per-asset`
}
export const ROADMAP_NET_ZERO_CHARTS_CUMULATIVE = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/roadmaps/charts/net-zero/cumulative`
}
export const COUNTRIES_URL = '/api/countries'
export const PROPERTY_TYPES_URL = '/api/property-types'

export const METERS_FILTERS_SURVEY_API_URL = (portfolio_id: string): string => {
    return `/api/surveys/meters/${portfolio_id}`
}
export const ROADMAP_CHARTS_API_URL = (portfolio_id: string, chart_type: string): string => {
    return `/api/portfolios/${portfolio_id}/roadmaps/charts/${chart_type}`
}
export const ROADMAP_CHARTS_API_URL_V2 = (portfolio_id: number, chart_type: string): string => {
    return `/api/portfolios/${portfolio_id}/roadmaps/charts/v2/${chart_type}`
}
export const ROADMAP_AUDIT_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/roadmaps/charts/audit-export`
}
export const ROADMAP_ASSET_DISTRIBUTION_API_URL_V2 = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/roadmaps/charts/asset-distribution`
}
export const ESG_CHARTS_API_URL = (portfolio_id: number | string, type = 'location-based'): string => {
    return `/api/portfolios/${portfolio_id}/esg-charts/ghg/${type}`
}
export const COMPANY_ESG_CHARTS_GHG_API_URL = (company_id: number, type = 'location-based'): string => {
    return `/api/companies/${company_id}/esg-charts/ghg/${type}`
}
export const ESG_CHARTS_ENERGY_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/esg-charts/energy`
}
export const ESG_CHARTS_ENERGY_PER_ASSET_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/esg-charts/energy/per-asset`
}
export const ESG_CHARTS_ENERGY_CUMULATIVE_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/esg-charts/energy/cumulative`
}
export const ESG_CHARTS_ENERGY_CONSUMPTION_BY_AREA_TYPE_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/esg-charts/energy/consumption-by-area-type`
}
export const COMPANY_ESG_CHARTS_ENERGY_PER_ASSET_API_URL = (company_id: number): string => {
    return `/api/companies/${company_id}/esg-charts/energy/per-asset`
}
export const COMPANY_ESG_CHARTS_ENERGY_CUMULATIVE_API_URL = (company_id: number): string => {
    return `/api/companies/${company_id}/esg-charts/energy/cumulative`
}
export const COMPANY_ESG_CHARTS_ENERGY_CUMULATIVE_PER_PORTFOLIO_API_URL = (company_id: number): string => {
    return `/api/companies/${company_id}/esg-charts/energy/cumulative/per-portfolio`
}
export const GOVERNANCE_TARGET_ANSWERS_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/governance/target-answers`
}
export const GOVERNANCE_ANSWERS_API_URL = (portfolio_id: string | number): string => {
    return `/api/portfolios/${portfolio_id}/governance`
}
export const GOVERNANCE_DOCUMENTS_API_URL = (portfolio_id: number | string): string => {
    return `/api/portfolios/${portfolio_id}/governance/documents`
}
export const GOVERNANCE_DOCUMENTS_UPLOAD_API_URL = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/governance/documents/upload`
}
export const GOVERNANCE_DOCUMENTS_BULK_UPLOAD_API_URL = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/governance/documents/upload-bulk`
}
export const GOVERNANCE_STATISTICS_API_URL = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/governance/statistics`
}
export const GOVERNANCE_DOWNLOAD_DOCUMENT_API_URL = (portfolio_id: number | string, governance_document_id: string): string => {
    return `/api/portfolios/${portfolio_id}/governance/documents/${governance_document_id}/download`
}
export const GOVERNANCE_SINGLE_DOCUMENT_API_URL = (portfolio_id: string, governance_document_id: string): string => {
    return `/api/portfolios/${portfolio_id}/governance/documents/${governance_document_id}`
}
export const PORTFOLIO_INFO_URL = (portfolio_id: string | number): string => {
    return `/api/portfolios/${portfolio_id}/info`
}
export const OUTPUT_CHARTS_API_URL = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/output-charts`
}
export const COMPANY_OUTPUT_CHARTS_API_URL = (company_id: string): string => {
    return `/api/companies/${company_id}/output-charts`
}
export const GENERATE_REPORT_API_URL = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/reports/generate`
}
export const GENERATE_COMPANY_WIDE_REPORT_API_URL = (company_id: string): string => {
    return `/api/companies/${company_id}/reports/generate`
}
export const GET_PORTFOLIO = (portfolio_id: string | number): string => {
    return `/api/portfolios/${portfolio_id}`
}
export const GET_PORTFOLIO_VALUES = (portfolio_id: string | number) => {
    return `/api/portfolios/${portfolio_id}/offered-values`
}
export const UPDATE_PORTFOLIO = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}`
}
export const TOGGLE_WEATHER_NORMALIZATION_URL = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/toggle-weather-normalization`
}
export const DELETE_PORTFOLIO = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}`
}
export const GET_PERIOD_LOCK = (portfolio_id: string | number): string => {
    return `/api/portfolios/${portfolio_id}/period-lock`
}
export const UPDATE_PERIOD_LOCK = (portfolio_id: string | number): string => {
    return `/api/portfolios/${portfolio_id}/period-lock`
}
export const DELETE_PERIOD_LOCK = (portfolio_id: string | number): string => {
    return `/api/portfolios/${portfolio_id}/period-lock`
}
export const GET_LIST_OF_REGIONS = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/regions`
}
export const UPSERT_REGION = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/regions`
}
export const DELETE_REGION = (portfolio_id: string, region_id: number): string => {
    return `/api/portfolios/${portfolio_id}/regions/${region_id}`
}
export const GET_LOCATION_BASED_FACTOR_TYPES = () => {
    return `/api/emission-factor-types`
}
export const GET_LOCATION_BASED_COUNTRIES = (portfolio_id: string) => {
    return `/api/portfolios/${portfolio_id}/regions`
}
export const GET_LOCATION_BASED_FACTORS_BY_COUNTRY = (portfolio_id: string) => {
    return `/api/portfolios/${portfolio_id}/emission-factors/lb`
}
export const GENERATE_LOCATION_BASED_FACTORS = (portfolio_id: string) => {
    return `/api/portfolios/${portfolio_id}/emission-factors/lb/generate`
}
export const BULK_UPDATE_LOCATION_BASED_FACTORS = (portfolio_id: string) => {
    return `/api/portfolios/${portfolio_id}/emission-factors/lb/bulk-upsert`
}
export const GET_MARKET_BASED_EMISSION_FACTORS = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/emission-factors/mb`
}
export const BULK_UPDATE_MARKET_BASED_EMISSION_FACTORS = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/emission-factors/mb/bulk-upsert`
}
export const DOWNLOAD_LOCATION_BASED_EMISSION_FACTORS = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/emission-factors/lb/download`
}
export const DOWNLOAD_MARKET_BASED_EMISSION_FACTORS = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/emission-factors/mb/download`
}
export const DELETE_EMISSION_FACTOR = (portfolio_id: string, id: number): string => {
    return `/api/portfolios/${portfolio_id}/emission-factors/${id}`
}
export const UPSERT_MARKET_BASED_EMISSION_FACTOR = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/emission-factors/mb`
}
export const DELETE_MARKET_BASED_EMISSION_FACTOR = (portfolio_id: string, id: number): string => {
    return `/api/portfolios/${portfolio_id}/emission-factors/mb/${id}`
}
export const GET_CUSTOM_EMISSION_FACTOR_STATUS = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/lb-emission-factors-status`
}
export const GET_LIST_OF_WEATHER_STATIONS = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/weather-stations`
}
export const UPDATE_WEATHER_STATION = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/weather-stations`
}
export const DELETE_WEATHER_STATION = (portfolio_id: string, station_id: number): string => {
    return `/api/portfolios/${portfolio_id}/weather-stations/${station_id}`
}
export const GET_WEATHER_NORMALIZATION = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/weather-normalization`
}
export const BULK_UPDATE_WEATHER_NORMALIZATION = (portfolio_id: string): string => {
    return `/api/portfolios/${portfolio_id}/weather-normalization/bulk-upsert`
}
export const PUBLISH_REPORT_API_URL = (report_id: string): string => {
    return `/api/reports/${report_id}/publish`
}
export const DOWNLOAD_REPORT_API_URL = (report_id: string): string => {
    return `/api/reports/${report_id}/download`
}
export const DOWNLOAD_COMPANY_REPORT_API_URL = (report_id: string): string => {
    return `/api/companies/reports/${report_id}/download`
}
export const REPORT_JOB_STATUS_API_URL = (job_id: string): string => {
    return `/api/reports/jobs/${job_id}/status`
}
export const COMPANY_REPORT_JOB_STATUS_API_URL = (job_id: string): string => {
    return `/api/companies/reports/jobs/${job_id}/status`
}
export const ROADMAP_TARGETS_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/targets/all`
}
export const DEFAULT_ROADMAP_TARGETS_TOGGLE_API_URL = (portfolio_id: number, action: 'enable' | 'disable'): string => {
    return `/api/portfolios/${portfolio_id}/targets/default/${action}`
}
export const CREATE_CUSTOM_ROADMAP_TARGET_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/targets/custom`
}
export const GET_CUSTOM_ROADMAP_TARGET_API_URL = (portfolio_id: number, target_id: number): string => {
    return `/api/portfolios/${portfolio_id}/targets/custom/${target_id}`
}
export const UPDATE_CUSTOM_ROADMAP_TARGET_API_URL = (portfolio_id: number, target_id: number): string => {
    return `/api/portfolios/${portfolio_id}/targets/custom/${target_id}`
}
export const DELETE_CUSTOM_ROADMAP_TARGET_API_URL = (portfolio_id: number, target_id: number): string => {
    return `/api/portfolios/${portfolio_id}/targets/custom/${target_id}`
}
export const GET_TARGETS_OFFERED_VALUES = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/targets/custom/offered-values`
}
export const BENCHMARKS_ALL_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/benchmarks/all`
}
export const GET_CUSTOM_BENCHMARKS_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/benchmarks/custom`
}
export const GET_CUSTOM_BENCHMARK_API_URL = (portfolio_id: number, benchmark_id: number): string => {
    return `/api/portfolios/${portfolio_id}/benchmarks/custom/${benchmark_id}`
}
export const CREATE_CUSTOM_BENCHMARK_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/benchmarks/custom`
}
export const UPDATE_CUSTOM_BENCHMARK_API_URL = (portfolio_id: number, benchmark_id: number): string => {
    return `/api/portfolios/${portfolio_id}/benchmarks/custom/${benchmark_id}`
}
export const DELETE_CUSTOM_BENCHMARK_API_URL = (portfolio_id: number, benchmark_id: number): string => {
    return `/api/portfolios/${portfolio_id}/benchmarks/custom/${benchmark_id}`
}
export const TOGGLE_DEFAULT_BENCHMARK_API_URL = (portfolio_id: number, benchmark_id: number): string => {
    return `/api/portfolios/${portfolio_id}/benchmarks/default/${benchmark_id}/toggle`
}
export const GET_BENCHMARKS_OFFERED_VALUES = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/benchmarks/custom/offered-values`
}
export const GET_CURRENT_USE_INTENSITY_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/targets/suggested`
}
export const IN_ASSET_DETAILS_API_URL = (portfolio_id: number, asset_id: string | number | ''): string => {
    return `/api/portfolios/${portfolio_id}/in-asset-details/${asset_id}`
}
export const PORTFOLIO_VALIDATION_DETAILS_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/validation-details`
}
export const PORTFOLIO_CERTIFICATIONS_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/certifications`
}
export const PORTFOLIO_CERTIFICATIONS_OVERVIEW_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/certifications/overview`
}
export const PORTFOLIO_CERTIFICATIONS_ASSETS_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/certifications/assets`
}
export const IN_ASSET_DETAILS_DROPDOWN_VALUES_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-asset-details/offered-values`
}
export const GET_IN_ASSET_DETAILS_MAPPINGS_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/asset-mappings`
}
export const IN_ASSET_DETAILS_MAPPING_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/asset-mappings/${asset_id}`
}
export const DELETE_IN_ASSET_DETAILS_SINGLE_MAPPING_URL = (
    portfolio_id: number,
    mapping_id: number,
): string => {
    return `/api/portfolios/${portfolio_id}/asset-mappings/mapping/${mapping_id}`
}
export const IN_ASSET_DETAILS_MAPPING_STATS_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/asset-mappings/statistics`
}
export const IN_MAPPING_DOWNLOAD_TEMPLATE_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/download-mapping-template`
}
export const IN_MAPPING_UPLOAD_MAPPING_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/upload-mapping`
}
export const IN_MAPPING_DOWNLOAD_MAPPING_ERRORS_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/download-mapping-errors`
}
export const GET_IN_METER_MAPPINGS_URL = (asset_id: number): string => {
    return `/api/assets/${asset_id}/meter-mappings`
}
export const GET_IN_METER_MAPPING_BY_METER_ID_URL = (asset_id: number, meter_id: number): string => {
    return `/api/assets/${asset_id}/meter-mappings/${meter_id}`
}
export const GET_IN_METER_HISTORY_MAPPING_URL = (asset_id: number, meter_history_id: number): string => {
    return `/api/assets/${asset_id}/meter-mappings/${meter_history_id}`
}
export const GET_IN_METER_MAPPINGS_STATS_URL = (asset_id: number): string => {
    return `/api/assets/${asset_id}/meter-mappings/stats`
}
export const DELETE_IN_METER_MAPPING_URL = (asset_id: number, in_meter_history_id: number): string => {
    return `/api/assets/${asset_id}/meter-mappings/${in_meter_history_id}`
}
export const INTEGRATION_ASSET_METERS_URL = (asset_id: number): string => {
    return `/api/assets/${asset_id}/integrations/meters`
}
export const INTEGRATION_METERS_BY_EXTERNAL_ID_URL = (asset_id: number, external_meter_id: number): string => {
    return `/api/assets/${asset_id}/integrations/meters/${external_meter_id}`
}
export const INTEGRATION_CLIENT_PROPERTIES_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/integrations/properties`
}
export const INTEGRATION_CLIENT_PROPERTY_BY_ID_URL = (portfolio_id: number, external_property_id: number): string => {
    return `/api/portfolios/${portfolio_id}/integrations/properties/${external_property_id}`
}
export const IN_CONSTRUCTION_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-construction/${asset_id}`
}
export const IN_CONSTRUCTION_OFFERED_VALUES_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-construction/offered-values`
}
export const IN_CONSTRUCTION_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-construction/${asset_id}/${item_id}`
}
export const IN_ESG_DATA_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-esg-data/${asset_id}`
}
export const IN_ESG_DATA_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: string | number | '',
): string => {
    return `/api/portfolios/${portfolio_id}/in-esg-data/${asset_id}/${item_id}`
}
export const IN_ESG_DATA_OFFERED_VALUES_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-esg-data/offered-values`
}
export const IN_CERTIFICATIONS_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-certifications/${asset_id}`
}
export const IN_CERTIFICATIONS_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: string | number | '',
): string => {
    return `/api/portfolios/${portfolio_id}/in-certifications/${asset_id}/${item_id}`
}
export const IN_CERTIFICATIONS_OFFERED_VALUES_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-certifications/offered-values`
}
export const IN_METERS_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-meters/${asset_id}`
}
export const IN_METERS_IDS_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-meters/${asset_id}/ids`
}
export const IN_METERS_COVERAGE_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-meters/${asset_id}/coverage`
}
export const IN_METERS_API_ITEM_URL = (portfolio_id: number, asset_id: number, meter_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-meters/${asset_id}/${meter_id}`
}
export const IN_METERS_OFFERED_VALUES_API_URL = (portfolio_id: number, asset_id?: number): string => {
    return `/api/portfolios/${portfolio_id}/in-meters/offered-values/${asset_id ?? ''}`
}

export const IN_METERS_DATA_EXPORT_API_URL = (portfolio_id: number, meter_ids: string): string => {
    return `/api/portfolios/${portfolio_id}/in-meters/export/${meter_ids}`
}

export const IN_METERS_DATA_EXPORT_ALL_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-meters/export-all`
}

export const IN_METERS_AGGREGATIONS_API_URL = (portfolio_id: number, asset_id: number, meter_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-meters/${asset_id}/${meter_id}/aggregations`
}

export const IN_METERS_AGGREGATION_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    meter_id: number,
    aggregation_id: number,
): string => {
    return `/api/portfolios/${portfolio_id}/in-meters/${asset_id}/${meter_id}/aggregations/${aggregation_id}`
}

export const IN_METERS_HISTORY_API_URL = (portfolio_id: number, asset_id: number, meter_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-meters/${asset_id}/${meter_id}/history`
}
export const IN_METERS_HISTORY_VERSION_API_URL = (portfolio_id: number, asset_id: number, meter_id: number, version: number): string => {
    return `/api/portfolios/${portfolio_id}/in-meters/${asset_id}/${meter_id}/history/${version}`
}
export const IN_METERS_HISTORY_CLOSE_API_URL = (portfolio_id: number, asset_id: number, meter_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-meters/${asset_id}/${meter_id}/history/close`
}
export const IN_METERS_CONSUMPTIONS_API_URL = (portfolio_id: number, asset_id: number, meter_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-meters/${asset_id}/${meter_id}/consumptions`
}

export const IN_METERS_CALCULATED_METER_CONSUMPTIONS_API_URL = (portfolio_id: number, asset_id: number, meter_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-meters/${asset_id}/${meter_id}/output-consumptions`
}
export const IN_METERS_CONSUMPTION_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    meter_id: number,
    consumption_id: number,
): string => {
    return `/api/portfolios/${portfolio_id}/in-meters/${asset_id}/${meter_id}/consumptions/${consumption_id}`
}
export const IN_METERS_BUILDING_UNIT_LINKS_API_URL = (
    portfolio_id: number,
    asset_id: number,
    meter_id: number,
): string => {
    return `/api/portfolios/${portfolio_id}/in-meters/${asset_id}/${meter_id}/in-building-units`
}
export const IN_INSTALLATIONS_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-installations/${asset_id}`
}
export const IN_INSTALLATIONS_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-installations/${asset_id}/${item_id}`
}
export const IN_INSTALLATIONS_OFFERED_VALUES_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-installations/offered-values`
}
export const PORTFOLIO_ASSETS_API_URL = (portfolio_id: number, fields: string[]): string => {
    return `/api/portfolios/${portfolio_id}/assets?fields=${fields.join(',')}`
}
export const IN_DEVELOPMENT_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-development/${asset_id}`
}
export const IN_DEVELOPMENT_OFFERED_VALUES_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-development/offered-values`
}
export const IN_DEVELOPMENT_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-development/${asset_id}/${item_id}`
}
export const IN_EVIDENCES_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-evidences/${asset_id}`
}
export const IN_EVIDENCES_DOWNLOAD_API_URL = (portfolio_id: number, evidence_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-evidences/${evidence_id}/download`
}
export const IN_EVIDENCES_UPLOAD_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-evidences/${asset_id}/upload`
}
export const IN_EVIDENCES_UPLOAD_BULK_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-evidences/${asset_id}/upload-bulk`
}
export const IN_EVIDENCES_SINGLE_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    evidence_id: number,
): string => {
    return `/api/portfolios/${portfolio_id}/in-evidences/${asset_id}/${evidence_id}`
}
export const IN_REPORTING_DATA_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-reporting-data/${asset_id}`
}
export const IN_REPORTING_DATA_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-reporting-data/${asset_id}/${item_id}`
}
export const IN_REPORTING_DATA_OFFERED_VALUES_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-reporting-data/offered-values`
}
export const IN_CLIMATE_ADAPTATION_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-climate-adaptation-plan/${asset_id}`
}
export const IN_CLIMATE_ADAPTATION_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-climate-adaptation-plan/${asset_id}/${item_id}`
}
export const IN_LOAN_DATA_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-loan-data/${asset_id}`
}
export const IN_LOAN_DATA_ITEM_API_URL = (portfolio_id: number, asset_id: number, item_id: number | string): string => {
    return `/api/portfolios/${portfolio_id}/in-loan-data/${asset_id}/${item_id}`
}
export const IN_LOAN_DATA_OFFERED_VALUES_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-loan-data/offered-values`
}
export const IN_FINANCIAL_DATA_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-financial-data/${asset_id}`
}
export const IN_FINANCIAL_DATA_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-financial-data/${asset_id}/${item_id}`
}
export const IN_FINANCIAL_DATA_OFFERED_VALUES_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-financial-data/offered-values`
}
export const IN_PHYSICAL_CLIMATE_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-physical-climate/${asset_id}`
}
export const IN_PHYSICAL_CLIMATE_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-physical-climate/${asset_id}/${item_id}`
}
export const IN_PHYSICAL_CLIMATE_OFFERED_VALUES_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-physical-climate/offered-values`
}
export const IN_IMPACT_INVESTING_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-impact-investing/${asset_id}`
}
export const IN_IMPACT_INVESTING_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-impact-investing/${asset_id}/${item_id}`
}
export const IN_IMPACT_INVESTING_OFFERED_VALUES_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-impact-investing/offered-values`
}
export const IN_IMPACT_INITIATIVES_COMMUNITY_PROGRAM_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-impact-initiatives-community-program/${asset_id}`
}
export const IN_IMPACT_INITIATIVES_COMMUNITY_PROGRAM_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-impact-initiatives-community-program/${asset_id}/${item_id}`
}
export const IN_IMPACT_INITIATIVES_COMMUNITY_PROGRAM_OFFERED_VALUES_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-impact-initiatives-community-program/offered-values`
}
export const IN_IMPACT_INITIATIVES_ECOLOGY_INITIATIVE_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-impact-initiatives-ecology-initiative/${asset_id}`
}
export const IN_IMPACT_INITIATIVES_ECOLOGY_INITIATIVE_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-impact-initiatives-ecology-initiative/${asset_id}/${item_id}`
}
export const IN_IMPACT_INITIATIVES_ECOLOGY_INITIATIVE_OFFERED_VALUES_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-impact-initiatives-ecology-initiative/offered-values`
}
export const IN_IMPACT_INITIATIVES_PLACES_CREATED_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-impact-initiatives-places-created/${asset_id}`
}
export const IN_IMPACT_INITIATIVES_PLACES_CREATED_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-impact-initiatives-places-created/${asset_id}/${item_id}`
}
export const IN_IMPACT_INITIATIVES_PLACES_CREATED_OFFERED_VALUES_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-impact-initiatives-places-created/offered-values`
}
export const IN_IMPACT_INITIATIVES_PUBLIC_FACILITIES_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-impact-initiatives-public-facilities/${asset_id}`
}
export const IN_IMPACT_INITIATIVES_PUBLIC_FACILITIES_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-impact-initiatives-public-facilities/${asset_id}/${item_id}`
}
export const IN_IMPACT_INITIATIVES_PUBLIC_FACILITIES_OFFERED_VALUES_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-impact-initiatives-public-facilities/offered-values`
}
export const IN_EMBODIED_CARBON_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-embodied-carbon/${asset_id}`
}
export const IN_EMBODIED_CARBON_OFFERED_VALUES_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-embodied-carbon/offered-values`
}
export const IN_EMBODIED_CARBON_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-embodied-carbon/${asset_id}/${item_id}`
}
export const IN_BUILDING_UNITS_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-building-units/${asset_id}`
}
export const IN_BUILDING_UNITS_SYNC_METERS_API_URL = (portfolio_id: number, asset_id: number, item_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-building-units/${asset_id}/${item_id}/in-meters/sync`
}
export const IN_BUILDING_UNITS_OFFERED_VALUES_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-building-units/offered-values`
}
export const IN_BUILDING_UNITS_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-building-units/${asset_id}/${item_id}`
}
export const IN_BUILDING_UNIT_SHOW_API_URL = (
    portfolio_id: number,
    asset_id: number,
    building_unit_id: number,
): string => {
    return `/api/portfolios/${portfolio_id}/in-building-units/${asset_id}/${building_unit_id}`
}
export const IN_BUILDING_UNITS_COMMON_AREAS_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-building-units/${asset_id}/${item_id}/gross-floor-areas`
}
export const IN_BUILDING_UNITS_COMMON_AREAS_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
    unit_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-building-units/${asset_id}/${item_id}/gross-floor-areas/${unit_id}`
}
export const IN_BUILDING_UNITS_TENANT_AREAS_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-building-units/${asset_id}/${item_id}/gross-usable-areas`
}
export const IN_BUILDING_UNITS_TENANT_AREAS_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
    unit_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-building-units/${asset_id}/${item_id}/gross-usable-areas/${unit_id}`
}
export const IN_BUILDING_UNITS_VACANCY_PERIODS_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-building-units/${asset_id}/${item_id}/vacancy-periods`
}
export const IN_BUILDING_UNITS_VACANCY_PERIODS_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
    unit_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-building-units/${asset_id}/${item_id}/vacancy-periods/${unit_id}`
}
export const IN_BUILDING_UNITS_CERTIFICATIONS_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-building-units/${asset_id}/${item_id}/certifications`
}
export const IN_BUILDING_UNITS_CERTIFICATIONS_OFFERED_VALUES_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-building-units/${asset_id}/${item_id}/certifications/offered-values`
}
export const IN_BUILDING_UNITS_CERTIFICATIONS_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
    certification_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-building-units/${asset_id}/${item_id}/certifications/${certification_id}`
}
export const BUILDING_UNIT_ESG_OUTPUTS_API_URL = (
    portfolio_id: number,
    asset_id: number,
    building_unit_id: number,
    reporting_year: number,
): string => {
    return `/api/portfolios/${portfolio_id}/in-building-units/${asset_id}/${building_unit_id}/esg-outputs?reporting_year=${reporting_year}`
}
export const PORTFOLIOS_OVERVIEW_API_URL = '/api/portfolios/overview'

export const COMPANIES_ANALYTICS_CHARTS_API_URL = (company_id: number): string => {
    return `/api/companies/${company_id}/charts`
}
export const GET_ASPECT_AVERAGE_SCORES_API_URL = () => {
    return `/api/charts/scores/aspects-average-scores`
}
export const GET_GRESB_CHARTS_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/gresb-charts`
}
export const GET_COMPANY_ESG_CHARTS_DATA_API_URL = (company_id: number) => {
    return `/api/companies/${company_id}/esg-charts`
}
export const ASSET_MEASURE_STATUSES_URL = '/api/asset-measure-statuses'
export const CURRENCIES_URL = '/api/currencies'
export const ASSET_MEASURE_TYPE_CATEGORIES_URL = '/api/asset-measure-type-categories'
export const SINGLE_ASSET_MEASURE_URL = (asset_id: string | number, measure_id: string | number): string => {
    return `/api/assets/${asset_id}/measures/${measure_id}`
}
export const SINGLE_MEASURE_URL = (measure_id: string | number): string => {
    return `/api/measures/${measure_id}/show`
}
export const DOWNLOAD_DATA_QUALITY_THRESHOLDS_URL = () => {
    return `/api/assets/download-data-quality-thresholds`
}
export const MEASURES_STATISTICS_URL = () => {
    return `/api/measures/statistics`
}
export const MEASURES_FILTERS_URL = () => {
    return `/api/measures/filters`
}
export const PORTFOLIO_MEASURES_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/measures`
}
export const ASSET_OVERVIEW_URL = (asset_id: number) => {
    return `/api/assets/${asset_id}/overview`
}
export const API_PORTFOLIO_EU_TAXONOMY_DATA_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/regulatory-charts/eu-taxonomy`
}
export const TOTAL_INVESTMENTS_CHART_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/roadmaps/charts/total-investments`
}
export const ROADMAP_ACQUISITION_BULK_DUPLICATE_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/roadmaps/acquisitions/duplicate`
}
export const ROADMAP_ACQUISITION_BULK_CHANGE_STATUS_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/roadmaps/acquisitions/change-status`
}
export const ROADMAP_ACQUISITION_BULK_DELETE_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/roadmaps/acquisitions/bulk-delete`
}
export const ROADMAP_MEASURES_BULK_DUPLICATE_API_URL = () => {
    return `/api/measures/duplicate`
}
export const ROADMAP_MEASURES_BULK_CHANGE_STATUS_API_URL = () => {
    return `/api/measures/change-status`
}
export const ROADMAP_MEASURES_BULK_DELETE_API_URL = () => {
    return `/api/measures/bulk-delete`
}
export const ACQUISITION_FILTERS_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/roadmaps/acquisition-filters`
}
export const ASSET_VALIDATION_STATUS_API_URL = (asset_id: number) => {
    return `/api/assets/${asset_id}/validation-status`
}
export const ASSET_VALIDATION_DETAILS_API_URL = (asset_id: number): string => {
    return `/api/assets/${asset_id}/validation-details`
}
export const SUPPLIERS_LIST_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/suppliers`
}
export const SUPPLIERS_UPSERT_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/suppliers`
}
export const SUPPLIERS_DELETE_API_URL = (portfolio_id: number, supplier_id: number) => {
    return `/api/portfolios/${portfolio_id}/suppliers/${supplier_id}`
}
export const IMPORTS_INPUTS_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/imports/inputs`
}
export const IMPORTS_DOWNLOAD_API_URL = (portfolio_id: number, import_id: number) => {
    return `/api/portfolios/${portfolio_id}/imports/download/${import_id}`
}

export const IN_METERS_OVERVIEW_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/in-meters/overview`
}
export const IN_METERS_OVERVIEW_IDS_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-meters/overview/ids`
}

export const IN_METERS_OVERVIEW_OFFERED_VALUES_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/in-meters/overview/offered-values`
}

export const IN_RENEWABLE_ENERGY_CONTRACT_API_URL = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-renewable-energy-contracts/${asset_id}`
}
export const IN_RENEWABLE_ENERGY_CONTRACT_ITEM_API_URL = (
    portfolio_id: number,
    asset_id: number,
    item_id: number | string,
): string => {
    return `/api/portfolios/${portfolio_id}/in-renewable-energy-contracts/${asset_id}/${item_id}`
}
export const IN_RENEWABLE_ENERGY_CONTRACT_OFFERED_VALUES_API_URL = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/in-renewable-energy-contracts/offered-values`
}

export const DUMP_PORTFOLIO_DATA_FOR_DEV_API_URL = (portfolio_id: number, asset_ids: string): string => {
    return `/api/dev/dump-portfolio-data/${portfolio_id}?asset_ids=${asset_ids}`
}

export const ASSETS_HAVE_CALCULATIONS_API_URL = '/api/assets/has-calculation-in-progress'

export const GET_ASSET_DATA_URL = (portfolio_id: string | number, asset_id: string | number, fields: string[]): string => {
    return `/api/portfolios/${portfolio_id}/assets/${asset_id}/data?asset_data_fields=${fields.join(',')}`
}

export const ASSET_DETAILS_API_URL = (portfolio_id: number, asset_id: number) => {
    return `/api/portfolios/${portfolio_id}/in-reporting-data/${asset_id}/aggregation`
}

export const PORTFOLIO_METRICS_CUSTOM_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/metrics-custom`
}

export const PORTFOLIO_METRICS_PER_ASSET_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/metrics-custom/per-asset`
}

export const PORTFOLIO_CALCULATION_STATUS_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/calculation-status`
}

export const COMPANY_DATA_COMPLETION_URL = (company_id: string | number): string => {
    return `/api/companies/${company_id}/health`
}

export const COMPANY_CALCULATION_STATUS_API_URL = (company_id: number): string => {
    return `/api/companies/${company_id}/calculation-status`
}

export const PORTFOLIO_DOCUMENTS_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/documents`
}

export const PORTFOLIO_REPORT_HISTORY_API_URL = (portfolioId: number, reportingYear: number, framework?: string) => {
    const params = new URLSearchParams({ reporting_year: reportingYear.toString() })
    if (framework) {
        params.append('framework', framework)
    }
    return `/api/portfolios/${portfolioId}/reports/history?${params.toString()}`
}

export const PORTFOLIO_DOCUMENT_DOWNLOAD_API_URL = (document_id: number) => {
    return `/api/reports/${document_id}/download`
}

export const DELETE_PORTFOLIO_DOCUMENT_API_URL = (portfolio_id: number, document_id: number) => {
    return `/api/portfolios/${portfolio_id}/documents/${document_id}`
}

export const ASSET_ENGAGEMENT_API_URL = (asset_id: number) => {
    return `/api/assets/${asset_id}/engagement`
}

export const ASSETS_PHYSICAL_CLIMATE_RISKS_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/in-asset-details/physical-climate-risks`
}

export const BUILDING_UNITS_ASSET_COVERAGE_API_URL = (portfolio_id: number, asset_id: number) => {
    return `/api/portfolios/${portfolio_id}/in-building-units/${asset_id}/coverage`
}

export const PORTFOLIO_COMMENTS_FIND_API_URL = (portfolio_id: number | string, commentable_type: string, year?: number | string) => {
    const params = new URLSearchParams({
        portfolio_id: portfolio_id.toString(),
        commentable_type: commentable_type,
    })
    if (year) {
        params.append('year', year.toString())
    }
    return `/api/comments?${params.toString()}`
}

export const PORTFOLIO_COMMENTS_API_URL = (comment_id: number | string) => {
    return `/api/comments/${comment_id}`
}

export const PORTFOLIO_COMMENTS_STORE_API_URL = () => {
    return `/api/comments`
}
export const ASSET_CALCULATION_STATUS_API_URL = (asset_id: number) => {
    return `/api/assets/${asset_id}/calculation-status`
}
export const PORTFOLIO_PHYSICAL_CLIMATE_RISKS_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/physical-climate-risks`
}

export const PORTFOLIO_WASTE_FACTORS_COUNTRIES_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/emission-factors/waste/countries`
}

export const PORTFOLIO_WASTE_FACTORS_FOR_COUNTRY_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/emission-factors/waste/for-country`
}

export const PORTFOLIO_BULK_UPSERT_WASTE_FACTORS_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/emission-factors/waste/bulk-upsert`
}

export const PORTFOLIO_WASTE_FACTORS_DOWNLOAD_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/emission-factors/waste/download`
}

export const GET_LIST_OF_DASHBOARDS_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/dashboards`
}
export const CREATE_DASHBOARD_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/dashboards`
}
export const GET_DASHBOARD_API_URL = (portfolio_id: number, dashboard_id: number) => {
    return `/api/portfolios/${portfolio_id}/dashboards/${dashboard_id}`
}
export const UPDATE_DASHBOARD_API_URL = (portfolio_id: number, dashboard_id: number) => {
    return `/api/portfolios/${portfolio_id}/dashboards/${dashboard_id}`
}
export const DELETE_DASHBOARD_API_URL = (portfolio_id: number, dashboard_id: number) => {
    return `/api/portfolios/${portfolio_id}/dashboards/${dashboard_id}`
}
export const DATA_REQUEST_API_URL = '/api/data-requests'
export const DATA_REQUEST_AVAILABLE_REVIEWERS_API_URL = (portfolioId: number | string) => `/api/data-requests/${portfolioId}/available-reviewers`

export const DATA_REQUEST_ID_API_URL = (data_request_id: string | '' = '') => {
    return `/api/data-requests/${data_request_id}`
}
export const DATA_REQUEST_SINGLE_ASSET_ID_API_URL = (data_request_asset_id: string | '' = '') => {
    return `/api/data-requests/assets/${data_request_asset_id}`
}
export const DATA_REQUEST_ASSETS_API_URL = (data_request_id: string | '' = '') => {
    return `/api/data-requests/${data_request_id}/assets`
}
export const DATA_REQUEST_ASSETS_DOWNLOAD_API_URL = (data_request_id: string | '' = '') => {
    return `/api/data-requests/${data_request_id}/assets/download`
}
export const DATA_REQUEST_DUPLICATE_API_URL = (id: string | number) => {
    return `/api/data-requests/${id}/duplicate`
}
export const DATA_REQUEST_BULK_REMIND_API_URL = (ids: string | number) => {
    return `/api/data-requests/${ids}/bulk-remind`
}
export const DATA_REQUEST_ASSET_UPDATE_STATUS_API_URL = (id: string | number) => {
    return `/api/data-requests/assets/${id}/update-status`
}
export const DATA_REQUEST_ASSET_STATISTICS_API_URL = (id: string | number) => {
    return `/api/data-requests/assets/${id}/statistics`
}
export const DATA_REQUEST_BULK_APPROVE_API_URL = '/api/data-requests/bulk-approve'
export const DATA_REQUEST_ASSET_COMMENTS_API_URL = (id: string | number) => {
    return `/api/data-request-asset-comments/${id}`
}
export const DATA_REQUEST_CHANGES_FIELD_FLAG_API_URL = (change_id: string | number) => {
    return `/api/data-request-changes/${change_id}/flag`
}
export const DATA_REQUEST_CHANGES_FIELD_REJECT_API_URL = (change_id: string | number) => {
    return `/api/data-request-changes/${change_id}/reject`
}

export const DATA_REQUEST_ASSET_UPLOAD_API_URL = (data_request_id: string | number): string => {
    return `/api/data-requests/${data_request_id}/upload`
}

export const DATA_REQUEST_ASSET_DOWNLOAD_UPLOAD_FILE_API_URL = (data_request_id: string | number, upload_id: string | number): string => {
    return `/api/data-requests/${data_request_id}/uploads/${upload_id}/download`
}

export const EXCEL_TEMPLATE_METADATA_API_URL = '/api/excel/template/metadata'

export const ASSET_BILL_SCRAPING_LIST = (portfolio_id: number, asset_id: number): string => {
    return `/api/portfolios/${portfolio_id}/assets/${asset_id}/bills/`
}

export const PORTFOLIO_BILL_SCRAPING_LIST = (portfolio_id: number): string => {
    return `/api/portfolios/${portfolio_id}/bills/`
}

export const ASSET_BILL_SCRAPING_UPLOAD_POST = (portfolio_id: number, asset_id: number): string =>
    `/api/portfolios/${portfolio_id}/assets/${asset_id}/bills/upload` // POST

export const ASSET_BILL_SCRAPING_GLOBAL_STATUS = (portfolio_id: number, asset_id: number): string =>
    `/api/portfolios/${portfolio_id}/assets/${asset_id}/bills/global-status`

export const ASSET_BILL_SCRAPING_MARK_AS_SEEN_PUT = (portfolio_id: number, asset_id: number): string =>
    `/api/portfolios/${portfolio_id}/assets/${asset_id}/bills/mark-as-seen`// PUT

export const PORTFOLIO_BILL_SCRAPING_UPLOAD_POST = (portfolio_id: number): string =>
    `/api/portfolios/${portfolio_id}/bills/upload` // POST

export const BILL_SCRAPING_CONSUMPTION = (portfolio_id: number, bill_scraping_id: number): string =>
    `/api/portfolios/${portfolio_id}/bills/${bill_scraping_id}/consumption`

export const BILL_SCRAPING_REVIEW = (portfolio_id: number, bill_scraping_id: number): string =>
    `/api/portfolios/${portfolio_id}/bills/${bill_scraping_id}/review`

export const PORTFOLIO_SCOPE_3_FACTORS_REGIONS_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/emission-factors/scope-3/regions`
}

export const PORTFOLIO_SCOPE_3_FACTORS_FOR_REGION_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/emission-factors/scope-3/for-region`
}

export const PORTFOLIO_BULK_UPSERT_SCOPE_3_FACTORS_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/emission-factors/scope-3/bulk-upsert`
}

export const PORTFOLIO_SCOPE_3_FACTORS_DOWNLOAD_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/emission-factors/scope-3/download`
}

export const ADVISORY_REQUEST_API_URL = '/api/advisory-request'

export const PORTFOLIO_LIST_PHYSICAL_CLIMATE_MEASURES_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/physical-climate/measure`
}

export const PORTFOLIO_PHYSICAL_CLIMATE_MEASURE_OFFERED_VALUES_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/physical-climate/measure/offered-values`
}

export const PORTFOLIO_CREATE_PHYSICAL_CLIMATE_MEASURE_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/physical-climate/measure`
}

export const PORTFOLIO_SHOW_PHYSICAL_CLIMATE_MEASURE_API_URL = (portfolio_id: number, measure_id: number) => {
    return `/api/portfolios/${portfolio_id}/physical-climate/measure/${measure_id}`
}

export const PORTFOLIO_UPDATE_PHYSICAL_CLIMATE_MEASURE_API_URL = (portfolio_id: number, measure_id: number) => {
    return `/api/portfolios/${portfolio_id}/physical-climate/measure/${measure_id}`
}

export const PORTFOLIO_DELETE_PHYSICAL_CLIMATE_MEASURE_API_URL = (portfolio_id: number, measure_id: number) => {
    return `/api/portfolios/${portfolio_id}/physical-climate/measure/${measure_id}`
}

export const PORTFOLIO_PHYSICAL_CLIMATE_MEASURES_TIMELINE_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/physical-climate/timeline`
}

export const GET_ASSET_GROUPS_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/asset-groups`
}

export const GET_ASSET_GROUP_API_URL = (portfolio_id: number, asset_group_id: number) => {
    return `/api/portfolios/${portfolio_id}/asset-groups/${asset_group_id}`
}

export const CREATE_ASSET_GROUP_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/asset-groups`
}

export const UPDATE_ASSET_GROUP_API_URL = (portfolio_id: number, asset_group_id: number) => {
    return `/api/portfolios/${portfolio_id}/asset-groups/${asset_group_id}`
}

export const DELETE_ASSET_GROUP_API_URL = (portfolio_id: number, asset_group_id: number) => {
    return `/api/portfolios/${portfolio_id}/asset-groups/${asset_group_id}`
}

export const LIST_ASSETS_IN_PORTFOLIO_WITH_ASSET_GROUP_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/asset-groups/assets`
}
export const CUSTOM_FIELD_DEFINITIONS_API_URL = (company_id: number) => {
    return `/api/companies/${company_id}/custom-field-definitions`
}
export const CUSTOM_FIELD_DEFINITIONS_ITEM_API_URL = (company_id: number, item_id: number) => {
    return `/api/companies/${company_id}/custom-field-definitions/${item_id}`
}
export const CUSTOM_FIELD_DEFINITIONS_REORDER_API_URL = (company_id: number) => {
    return `/api/companies/${company_id}/custom-field-definitions/reorder`
}
export const CUSTOM_FIELD_VALUES_API_URL = (portfolio_id: number, asset_id: number) => {
    return `/api/portfolios/${portfolio_id}/custom-fields/${asset_id}`
}
export const CUSTOM_FIELD_VALUE_API_URL = (portfolio_id: number, asset_id: number, custom_field_id: number) => {
    return `/api/portfolios/${portfolio_id}/custom-fields/${asset_id}/${custom_field_id}`
}
export const CUSTOM_FIELD_OFFERED_VALUES_API_URL = (portfolio_id: number) => {
    return `/api/portfolios/${portfolio_id}/custom-fields/offered-values`
}

export const COMPANY_GET_LIST_OF_DASHBOARDS_API_URL = (company_id: number) => {
    return `/api/companies/${company_id}/dashboards`
}
export const COMPANY_CREATE_DASHBOARD_API_URL = (company_id: number) => {
    return `/api/companies/${company_id}/dashboards`
}
export const COMPANY_GET_DASHBOARD_API_URL = (company_id: number, dashboard_id: number) => {
    return `/api/companies/${company_id}/dashboards/${dashboard_id}`
}
export const COMPANY_UPDATE_DASHBOARD_API_URL = (company_id: number, dashboard_id: number) => {
    return `/api/companies/${company_id}/dashboards/${dashboard_id}`
}
export const COMPANY_DELETE_DASHBOARD_API_URL = (portfolio_id: number, dashboard_id: number) => {
    return `/api/companies/${portfolio_id}/dashboards/${dashboard_id}`
}

// Draft Meters API URLs
export const IN_DRAFT_METERS_API_URL = (_portfolioId: number, assetId: number) => {
    return `/api/assets/${assetId}/draft-meters`
}
export const IN_DRAFT_METERS_STATISTICS_API_URL = (_portfolioId: number, assetId: number) => {
    return `/api/assets/${assetId}/draft-meters/statistics`
}
export const IN_DRAFT_METERS_SYNC_API_URL = (_portfolioId: number, assetId: number) => {
    return `/api/assets/${assetId}/draft-meters/sync`
}
export const IN_DRAFT_METERS_BULK_APPROVE_API_URL = (_portfolioId: number, assetId: number) => {
    return `/api/assets/${assetId}/draft-meters/bulk-approve`
}
export const IN_DRAFT_METERS_BULK_UPDATE_API_URL = (_portfolioId: number, assetId: number) => {
    return `/api/assets/${assetId}/draft-meters/bulk-update`
}
export const IN_DRAFT_METER_SHOW_API_URL = (_portfolioId: number, assetId: number, draftMeterId: string) => {
    return `/api/assets/${assetId}/draft-meters/${draftMeterId}`
}
export const IN_DRAFT_METER_UPDATE_API_URL = (_portfolioId: number, assetId: number, draftMeterId: string) => {
    return `/api/assets/${assetId}/draft-meters/${draftMeterId}`
}
export const IN_DRAFT_METER_APPROVE_API_URL = (_portfolioId: number, assetId: number, draftMeterId: string) => {
    return `/api/assets/${assetId}/draft-meters/${draftMeterId}/approve`
}
export const IN_DRAFT_METER_REJECT_API_URL = (_portfolioId: number, assetId: number, draftMeterId: string) => {
    return `/api/assets/${assetId}/draft-meters/${draftMeterId}/reject`
}
export const IN_DRAFT_METER_DELETE_API_URL = (_portfolioId: number, assetId: number, draftMeterId: string) => {
    return `/api/assets/${assetId}/draft-meters/${draftMeterId}`
}
export const IN_DRAFT_METERS_FILTERS_API_URL = (_portfolioId: number, assetId: number) => {
    return `/api/assets/${assetId}/draft-meters/filters`
}
export const IN_DRAFT_METERS_SYNC_STATUS_API_URL = (_portfolioId: number, assetId: number, syncInfoId: string) => {
    return `/api/assets/${assetId}/draft-meters/sync/${syncInfoId}/status`
}
export const IN_DRAFT_METERS_SYNC_PENDING_API_URL = (_portfolioId: number, assetId: number) => {
    return `/api/assets/${assetId}/draft-meters/sync/pending`
}

export const COMPANY_GET_LIST_OF_CUSTOM_CHARTS_API_URL = (company_id: number) => {
    return `/api/companies/${company_id}/custom-charts`
}
export const COMPANY_CREATE_CUSTOM_CHART_API_URL = (company_id: number) => {
    return `/api/companies/${company_id}/custom-charts`
}
export const COMPANY_GET_CUSTOM_CHART_API_URL = (company_id: number, chart_id: number) => {
    return `/api/companies/${company_id}/custom-charts/${chart_id}`
}
export const COMPANY_UPDATE_CUSTOM_CHART_API_URL = (company_id: number, chart_id: number) => {
    return `/api/companies/${company_id}/custom-charts/${chart_id}`
}
export const COMPANY_DELETE_CUSTOM_CHART_API_URL = (company_id: number, chart_id: number) => {
    return `/api/companies/${company_id}/custom-charts/${chart_id}`
}

// Audit Logs
export const AUDITS_API_URL = '/api/audits'
export const AUDIT_BY_ID_API_URL = (audit_id: string) => {
    return `/api/audits/${audit_id}`
}
export const AUDIT_ENTITY_HISTORY_API_URL = (entity_name: string, entity_id: string) => {
    return `/api/audits/entity/${entity_name}/${entity_id}/history`
}

export const AUDIT_BATCH_HISTORY_API_URL = '/api/audits/entity-history/batch'
